<script lang="ts" setup>
import { watch } from 'vue';
import type { RadioGroupProps as NRadioGroupProps } from 'naive-ui';
import type { CommonType } from '@/typings/common';

/** 单选组 */
export interface RadioGroupProps {
  options: CommonType.Option<string | number | boolean>[];
  /** 禁用 */
  disabled?: boolean;
  /** 大小 */
  size?: NRadioGroupProps['size'];
}
defineOptions({ name: 'RadioGroup', inheritAttrs: false });
defineProps<RadioGroupProps>();
const model = defineModel<boolean | string | number | null>('value');

const emit = defineEmits<{
  change: [value: boolean | string | number | null | undefined];
}>();

watch(model, value => {
  emit('change', value);
});
</script>

<template>
  <NRadioGroup v-model:value="model" :disabled="disabled" :size="size">
    <NSpace>
      <NRadio v-for="(option, index) in options" :key="index" :value="option.value">
        {{ option.label }}
      </NRadio>
    </NSpace>
  </NRadioGroup>
</template>

<style scoped></style>
